<template>
    <section class="order-receipt-section">
      <div class="knockout">
        <h3>Your Receipt</h3>
        <p>Order Reference Number - {{ customer.phone }}</p>
      </div>

      <h4>Receipt</h4>

      <div>
        {{ customer.firstName }} {{ customer.lastName }}<br/>
        {{ customer.address.city }}, {{ customer.address.state }}<br/>
        {{ customer.address.postal }}<br/>
        {{ customer.phone }}<br/>
        {{ customer.email }}<br/>
        <br/>
        Credit Card Type: {{ paymentInfo.cardType }}<br/>
        Credit Card Number: {{ paymentInfo.sanitizedCcNumber }}<br/>
        Credit Card Expiry: {{ paymentInfo.expiryDate }}
      </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'OrderReceipt',

  computed: {
    ...mapState(['customer', 'deliveryDate', 'partner', 'paymentInfo']),
  },

  mounted() {
    this.$store.dispatch('trackSpotifyPurchase');
    this.$store.dispatch('trackRedditPurchase');
  },

  beforeDestroy() {
    // Before leaving receipt page, reset store state
    this.prepEmptyOrder();
  },

  methods: {
    prepEmptyOrder() {
      this.$store.dispatch('prepEmptyOrder', this.customer.address.postal);
    },
  },
};
</script>

<style scoped>

.order-receipt-section {
  max-width: 768px;
  margin: 0 auto;
  padding-bottom: 2.62em;
}

.knockout {
  border-radius: .62em;
  background-color: #FFE52C;
  padding: .62em;
  margin: 1.62em 0;
  text-align: center;
}

</style>
